import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { ViewKnowledgeBase } from 'components/infoTech/components/viewKnowledgeBase';
import { TabPanel } from 'shared';

import { CreateKnowledgeBase } from './createKnowledgeBase';
import { ITSTIckets } from './itsTickets';

function ITSKnowledgeBase() {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewITSKnowledgeBase_tab" label="View Knowledge Base" value="0" />
                <Tab id="CreateKnowledgeBase_tab" label="Create Article" value="1" />
                <Tab id="ITSTickets_tab" label="Tickets" value="2" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewKnowledgeBase />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreateKnowledgeBase />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <ITSTIckets />
            </TabPanel>
        </Paper>
    );
}

export { ITSKnowledgeBase };
